import { useEffect, useRef } from "react";

const WHATSAPP_URL = "https://wa.me/5512991220961?text=Olá,%20sou%20pessoa%20física%20e%20gostaria%20de%20solicitar%20atendimento.";

const SERVICES = [
  {
    icon: "ri-shield-user-line",
    title: "Direito Previdenciário",
    desc: "Aposentadorias, benefícios por incapacidade, revisões de benefícios e ações para servidores públicos e trabalhadores da iniciativa privada.",
  },
  {
    icon: "ri-file-list-3-line",
    title: "Direito do Trabalho",
    desc: "Rescisões indevidas, horas extras, assédio moral, verbas trabalhistas e toda a defesa dos seus direitos como trabalhador.",
  },
  {
    icon: "ri-home-4-line",
    title: "Direito Civil",
    desc: "Contratos, responsabilidade civil, direito de família, inventários e questões patrimoniais com atendimento personalizado.",
  },
];

export default function PessoaFisicaSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const items = entry.target.querySelectorAll(".reveal-pf");
            items.forEach((item, i) => {
              setTimeout(() => {
                item.classList.add("opacity-100", "translate-y-0");
                item.classList.remove("opacity-0", "translate-y-8");
              }, i * 120);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="pessoa-fisica" ref={sectionRef} className="py-24 lg:py-32 bg-rose-pale/30">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="reveal-pf opacity-0 translate-y-8 transition-all duration-700 relative order-last lg:order-first">
            <div className="relative rounded-2xl overflow-hidden w-full h-[500px]">
              <img
                src="https://storage.readdy-site.link/project_files/9db3cce5-c9f8-4636-a3f8-f10d86795543/4c108bd1-b1c4-4d94-9974-9ddc95360b39_SM-ADVOGADOS-2.jpg?v=71b7442c560c873298cfb8c44538d05a"
                alt="Atendimento jurídico individual advogado previdenciário trabalhista"
                title="Atendimento jurídico para pessoa física – SM Advogados"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-grafite/20 to-transparent" />
            </div>
            {/* Floating card */}
            <div className="absolute -bottom-5 -right-5 bg-white rounded-xl px-5 py-4 border border-gray-light">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-rose-pale rounded-full">
                  <i className="ri-heart-line text-rose-primary text-lg" />
                </div>
                <div>
                  <p className="text-grafite font-semibold text-sm">Atendimento Humanizado</p>
                  <p className="text-grafite/50 text-xs">Do início ao fim do processo</p>
                </div>
              </div>
            </div>
          </div>

          {/* Text */}
          <div>
            <div className="reveal-pf opacity-0 translate-y-8 transition-all duration-700 flex items-center gap-3 mb-6">
              <div className="h-px w-10 bg-rose-primary" />
              <span className="text-rose-primary text-xs font-medium uppercase tracking-widest">Para Pessoa Física</span>
            </div>
            <h2 className="reveal-pf opacity-0 translate-y-8 transition-all duration-700 font-heading text-4xl lg:text-5xl text-grafite font-semibold leading-tight mb-6">
              Seus direitos defendidos<br />com <em className="text-rose-primary not-italic">dedicação</em> e cuidado
            </h2>
            <p className="reveal-pf opacity-0 translate-y-8 transition-all duration-700 text-grafite/65 text-base leading-relaxed mb-10">
              Oferecemos atendimento individualizado e humanizado, compreendendo cada situação para proporcionar a melhor solução jurídica possível para você e sua família.
            </p>

            {/* Service cards */}
            <div className="flex flex-col gap-4 mb-10">
              {SERVICES.map((service) => (
                <div
                  key={service.title}
                  className="reveal-pf opacity-0 translate-y-8 transition-all duration-700 group flex gap-4 p-5 rounded-xl bg-white border border-gray-light hover:border-rose-primary/30 hover:shadow-none transition-all"
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-rose-pale rounded-xl flex-shrink-0 group-hover:bg-rose-primary/15 transition-colors">
                    <i className={`${service.icon} text-rose-primary text-lg`} />
                  </div>
                  <div>
                    <h3 className="text-grafite font-semibold text-sm mb-1.5">{service.title}</h3>
                    <p className="text-grafite/55 text-xs leading-relaxed">{service.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA */}
            <div className="reveal-pf opacity-0 translate-y-8 transition-all duration-700">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-rose-primary hover:bg-rose-dark text-white font-medium px-8 py-4 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-base" />
                </div>
                Solicitar Atendimento
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
